module.exports = __webpack_public_path__ + "img/visa.36572556.svg";